import { JdAffix } from '@jdesign-vue/components/affix'
import { JdAlert } from '@jdesign-vue/components/alert'
import { JdAutocomplete } from '@jdesign-vue/components/autocomplete'
import { JdAvatar } from '@jdesign-vue/components/avatar'
import { JdBacktop } from '@jdesign-vue/components/backtop'
import { JdBadge } from '@jdesign-vue/components/badge'
import {
  JdBreadcrumb,
  JdBreadcrumbItem,
} from '@jdesign-vue/components/breadcrumb'
import { JdButton, JdButtonGroup } from '@jdesign-vue/components/button'
import { JdCalendar } from '@jdesign-vue/components/calendar'
import { JdCard } from '@jdesign-vue/components/card'
import { JdCarousel, JdCarouselItem } from '@jdesign-vue/components/carousel'
import { JdCascader } from '@jdesign-vue/components/cascader'
import { JdCascaderPanel } from '@jdesign-vue/components/cascader-panel'
import { JdCheckTag } from '@jdesign-vue/components/check-tag'
import {
  JdCheckbox,
  JdCheckboxButton,
  JdCheckboxGroup,
} from '@jdesign-vue/components/checkbox'
import { JdCol } from '@jdesign-vue/components/col'
import { JdCollapse, JdCollapseItem } from '@jdesign-vue/components/collapse'
import { JdCollapseTransition } from '@jdesign-vue/components/collapse-transition'
import { JdColorPicker } from '@jdesign-vue/components/color-picker'
import { JdConfigProvider } from '@jdesign-vue/components/config-provider'
import {
  JdAside,
  JdContainer,
  JdFooter,
  JdHeader,
  JdMain,
} from '@jdesign-vue/components/container'
import { JdDatePicker } from '@jdesign-vue/components/date-picker'
import {
  JdDescriptions,
  JdDescriptionsItem,
} from '@jdesign-vue/components/descriptions'
import { JdDialog } from '@jdesign-vue/components/dialog'
import { JdDivider } from '@jdesign-vue/components/divider'
import { JdDrawer } from '@jdesign-vue/components/drawer'
import {
  JdDropdown,
  JdDropdownItem,
  JdDropdownMenu,
} from '@jdesign-vue/components/dropdown'
import { JdEmpty } from '@jdesign-vue/components/empty'
import { JdFocusTrap } from '@jdesign-vue/components/focus-trap'
import { JdForm, JdFormItem } from '@jdesign-vue/components/form'
import { JdGuide, JdGuideHint } from '@jdesign-vue/components/guide'
import { JdIcon } from '@jdesign-vue/components/icon'
import { JdImage } from '@jdesign-vue/components/image'
import { JdImageViewer } from '@jdesign-vue/components/image-viewer'
import { JdInput } from '@jdesign-vue/components/input'
import { JdInputNumber } from '@jdesign-vue/components/input-number'
import { JdLink } from '@jdesign-vue/components/link'
import {
  JdMenu,
  JdMenuItem,
  JdMenuItemGroup,
  JdSubMenu,
} from '@jdesign-vue/components/menu'
import { JdPageHeader } from '@jdesign-vue/components/page-header'
import { JdPagination } from '@jdesign-vue/components/pagination'
import { JdPopconfirm } from '@jdesign-vue/components/popconfirm'
import { JdPopover } from '@jdesign-vue/components/popover'
import { JdPopper } from '@jdesign-vue/components/popper'
import { JdProgress } from '@jdesign-vue/components/progress'
import {
  JdRadio,
  JdRadioButton,
  JdRadioGroup,
} from '@jdesign-vue/components/radio'
import { JdRate } from '@jdesign-vue/components/rate'
import { JdResult } from '@jdesign-vue/components/result'
import { JdRow } from '@jdesign-vue/components/row'
import { JdScrollbar } from '@jdesign-vue/components/scrollbar'
import {
  JdOption,
  JdOptionGroup,
  JdSelect,
} from '@jdesign-vue/components/select'
import { JdSelectV2 } from '@jdesign-vue/components/select-v2'
import { JdSkeleton, JdSkeletonItem } from '@jdesign-vue/components/skeleton'
import { JdSlider } from '@jdesign-vue/components/slider'
import { JdSpace } from '@jdesign-vue/components/space'
import {
  JdStatistic,
  JdStatisticGroup,
} from '@jdesign-vue/components/statistic'
import { JdCountdown } from '@jdesign-vue/components/countdown'
import { JdStep, JdSteps } from '@jdesign-vue/components/steps'
import { JdSwitch } from '@jdesign-vue/components/switch'
import { JdTable, JdTableColumn } from '@jdesign-vue/components/table'
import { JdAutoResizer, JdTableV2 } from '@jdesign-vue/components/table-v2'
import { JdTabPane, JdTabs } from '@jdesign-vue/components/tabs'
import { JdTag } from '@jdesign-vue/components/tag'
import { JdText } from '@jdesign-vue/components/text'
import { JdTimePicker } from '@jdesign-vue/components/time-picker'
import { JdTimeSelect } from '@jdesign-vue/components/time-select'
import { JdTimeline, JdTimelineItem } from '@jdesign-vue/components/timeline'
import { JdTooltip } from '@jdesign-vue/components/tooltip'
import { JdTooltipV2 } from '@jdesign-vue/components/tooltip-v2'
import { JdTransfer } from '@jdesign-vue/components/transfer'
import { JdTree } from '@jdesign-vue/components/tree'
import { JdTreeSelect } from '@jdesign-vue/components/tree-select'
import { JdTreeV2 } from '@jdesign-vue/components/tree-v2'
import { JdUpload } from '@jdesign-vue/components/upload'
import { JdWatermark } from '@jdesign-vue/components/watermark'

import type { Plugin } from 'vue'

export default [
  JdAffix,
  JdAlert,
  JdAutocomplete,
  JdAutoResizer,
  JdAvatar,
  JdBacktop,
  JdBadge,
  JdBreadcrumb,
  JdBreadcrumbItem,
  JdButton,
  JdButtonGroup,
  JdCalendar,
  JdCard,
  JdCarousel,
  JdCarouselItem,
  JdCascader,
  JdCascaderPanel,
  JdCheckTag,
  JdCheckbox,
  JdCheckboxButton,
  JdCheckboxGroup,
  JdCol,
  JdCollapse,
  JdCollapseItem,
  JdCollapseTransition,
  JdColorPicker,
  JdConfigProvider,
  JdContainer,
  JdAside,
  JdFooter,
  JdHeader,
  JdMain,
  JdDatePicker,
  JdDescriptions,
  JdDescriptionsItem,
  JdDialog,
  JdDivider,
  JdDrawer,
  JdDropdown,
  JdDropdownItem,
  JdDropdownMenu,
  JdEmpty,
  JdFocusTrap,
  JdForm,
  JdFormItem,
  JdGuide,
  JdGuideHint,
  JdIcon,
  JdImage,
  JdImageViewer,
  JdInput,
  JdInputNumber,
  JdLink,
  JdMenu,
  JdMenuItem,
  JdMenuItemGroup,
  JdSubMenu,
  JdPageHeader,
  JdPagination,
  JdPopconfirm,
  JdPopover,
  JdPopper,
  JdProgress,
  JdRadio,
  JdRadioButton,
  JdRadioGroup,
  JdRate,
  JdResult,
  JdRow,
  JdScrollbar,
  JdSelect,
  JdOption,
  JdOptionGroup,
  JdSelectV2,
  JdSkeleton,
  JdSkeletonItem,
  JdSlider,
  JdSpace,
  JdStatistic,
  JdStatisticGroup,
  JdCountdown,
  JdSteps,
  JdStep,
  JdSwitch,
  JdTable,
  JdTableColumn,
  JdTableV2,
  JdTabs,
  JdTabPane,
  JdTag,
  JdText,
  JdTimePicker,
  JdTimeSelect,
  JdTimeline,
  JdTimelineItem,
  JdTooltip,
  JdTooltipV2,
  JdTransfer,
  JdTree,
  JdTreeSelect,
  JdTreeV2,
  JdUpload,
  JdWatermark,
] as Plugin[]
